import React from 'react'

export const MONTHS = [
  {
    id: 1,
    name: 'Jan'
  },
  {
    id: 2,
    name: 'Fév'
  },
  {
    id: 3,
    name: 'Mars'
  },
  {
    id: 4,
    name: 'Avr'
  },
  {
    id: 5,
    name: 'Mai'
  },
  {
    id: 6,
    name: 'Juin'
  },
  {
    id: 7,
    name: 'Juil'
  },
  {
    id: 8,
    name: 'Août'
  },
  {
    id: 9,
    name: 'Sept'
  },
  {
    id: 10,
    name: 'Oct'
  },
  {
    id: 11,
    name: 'Nov'
  },
  {
    id: 12,
    name: 'Déc'
  }
]

export default function MonthFilter({
  width = 335,
  currentFile,
  setEnabledMonths,
  enabledMonths
}) {
  const handleClick = month => {
    setEnabledMonths(enabled => enabled.filter(m => false).concat(month))
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: 600,
        margin: 'auto',
        pointerEvents: 'all',
        cursor: 'pointer'
      }}
    >
      {MONTHS.map(m => (
        <div
          key={m.id}
          style={{
            fontSize: '0.6rem', // edit paul 02.22.2021 -- 4 letter months in French
            textTransform: 'uppercase',
            lineHeight: 1.4,
            textAlign: 'center',
            color:
              currentFile && currentFile.month === m.id
                ? '#fff'
                : enabledMonths.includes(m.id)
                ? '#666'
                : '#666',
            // borderBottom: enabledMonths.includes(m.id) ? '3px solid #666' : undefined,
            fontWeight: 800
          }}
          onClick={() => handleClick(m.id)}
        >
          {m.name}
          <br />
          <img src={enabledMonths.includes(m.id) ? 'minus.svg' : 'plus.svg'} />
        </div>
      ))}
    </div>
  )
}
